import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doDEVELOPER_TOKEN_DELETE } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_DEVELOPER_TOKEN_DELETE = "REQUEST_DEVELOPER_TOKEN_DELETE";
export const doREQUEST_DEVELOPER_TOKEN_DELETE = createDoRequestAction(
  REQUEST_DEVELOPER_TOKEN_DELETE,
);

export const requestDeveloperTokenDeleteActionCreators = {
  doREQUEST_DEVELOPER_TOKEN_DELETE,
};

export function* requestDeveloperTokenDelete({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestDeveloperTokenDelete");
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        developerTokenId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_DEVELOPER_TOKEN_DELETE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { developerTokenId } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/developer-token-delete`,
    accessToken,
    data: {
      developerTokenId,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_DEVELOPER_TOKEN_DELETE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/developer-token-delete",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doDEVELOPER_TOKEN_DELETE({
      id: developerTokenId,
    }),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_DEVELOPER_TOKEN_DELETE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* developerTokenDeleteSaga() {
  yield takeEvery(REQUEST_DEVELOPER_TOKEN_DELETE as any, requestDeveloperTokenDelete);
}
